import { task_management } from "./task_management";
import * as ko from "knockout";
import { CustomObservables } from "CustomObservables";
import { step } from "../../original/step";
import * as _ from "lodash";
import {
  action_code,
  c_product_structure_serials_view,
  non_part_usage,
  part_need,
  time_commit_view,
  screenNote,
} from "../../extended";

import { attachment_wrapper } from "../attachment/request_attachment";
import { c_task_sparepart } from "./c_task_sparepart";
import { PartUsage, person, request_dto, team } from "organized";

export class task_management_extended extends task_management {
  //
  request: KnockoutObservable<request_dto>;
  //
  actual_end_dttm: any;
  actual_start_dttm: any;
  actual_travel_end_dttm: any;
  actual_travel_start_dttm: any;

  task_description: KnockoutObservable<string>;

  cust_prob_descr: KnockoutObservable<string>;
  customer_ref: KnockoutObservable<string>;
  wos_own_ref: KnockoutObservable<string>;
  user_def1: KnockoutObservable<string>;
  user_def15: KnockoutObservable<string>;
  user_def16: KnockoutObservable<string>;
  user_def13: KnockoutObservable<string>;
  req_user_def8: KnockoutObservable<string>;

  place_id_cust: KnockoutObservable<string>;
  place_cust_name: KnockoutObservable<string>;
  place_cust_address: KnockoutObservable<string>;
  email: KnockoutObservable<string>;
  phone: KnockoutObservable<string>;
  contact_full_name: KnockoutObservable<string>;
  machine_serial_id: KnockoutObservable<string>;
  part_id: KnockoutObservable<string>;
  equipment_no: KnockoutObservable<string>;
  location: KnockoutObservable<string>;
  sales_order: KnockoutObservable<string>;
  contract_type: KnockoutObservable<string>;
  contract_description: KnockoutObservable<string>;
  contract_des: KnockoutObservable<string>;
  installation_date: KnockoutObservable<string>;
  assigned_date: KnockoutObservable<any>;
  steps: KnockoutObservableArray<step>;
  partNeeds: KnockoutObservableArray<part_need>;
  action_code_no: KnockoutObservableArray<action_code>;
  nonPartUsage: KnockoutObservableArray<non_part_usage>;
  c_task_sparepart: KnockoutObservableArray<c_task_sparepart>;
  attachments: KnockoutObservableArray<attachment_wrapper>;
  canInteract: KnockoutObservable<boolean>;
  readonly: KnockoutComputed<boolean>;
  c_product_structure_serials_view: KnockoutObservableArray<c_product_structure_serials_view>;
  time_commit_view: KnockoutObservableArray<time_commit_view>;
  product_id: KnockoutObservable<string>;
  part_usage: KnockoutObservableArray<PartUsage>;
  readings: KnockoutObservableArray<any>;
  notes: KnockoutObservableArray<screenNote>;
  ext_reject_category: KnockoutObservable<string>;
  ext_rejection_remark: KnockoutObservable<string>;

  ext_hold_category: KnockoutObservable<string>;
  ext_hold_remark: KnockoutObservable<string>;

  team: KnockoutObservable<team>;

  is_historical_task: KnockoutObservable<boolean>; // used to make sure task is readonly in historical task detail

  //geolocation
  geocode_lat: KnockoutObservable<string>;
  geocode_long: KnockoutObservable<string>;

  person: KnockoutObservable<person>;

  task_template_id: KnockoutObservable<string>;

  constructor(item: any) {
    super(item);

    this.request = ko.observable(new request_dto(item.request));

    this.is_historical_task = ko.observable(item?.is_historical_task || false);
    this.actual_end_dttm = ko.observable();
    this.actual_start_dttm = ko.observable();
    this.actual_travel_end_dttm = ko.observable();
    this.actual_travel_start_dttm = ko.observable();
    this.ext_reject_category = ko.observable(item.ext_reject_category ?? "");
    this.ext_rejection_remark = ko.observable(item.ext_rejection_remark ?? "");

    this.ext_hold_category = ko.observable(item.ext_hold_category ?? "");
    this.ext_hold_remark = ko.observable(item.ext_hold_remark ?? "");

    this.pay_all_to_partner = ko.observable(item?.pay_all_to_partner == "Y" ? true : false);
    if (item?.actual_end_dttm && item?.actual_end_dttm !== "") {
      this.actual_end_dttm = this.toDateString(item.actual_end_dttm);
    }
    if (item?.actual_start_dttm && item?.actual_start_dttm !== "") {
      this.actual_start_dttm = this.toDateString(item.actual_start_dttm);
    }
    if (item?.actual_travel_end_dttm && item?.actual_travel_end_dttm !== "") {
      this.actual_travel_end_dttm = this.toDateString(item.actual_travel_end_dttm);
    }
    if (item?.actual_travel_start_dttm && item?.actual_travel_start_dttm !== "") {
      this.actual_travel_start_dttm = this.toDateString(item.actual_travel_start_dttm);
    }
    this.task_description = ko.observable(item?.description);
    this.user_def1 = ko.observable(item?.user_def1);
    this.user_def15 = ko.observable(item?.user_def15);
    this.place_id_cust = ko.observable(item?.place_id_cust);
    this.product_id = ko.observable(item?.product_id);
    if (item?.place) this.place_cust_name = ko.observable(item.place.name);
    if (item?.address) {
      this.place_cust_address = ko.observable(item.address.full_address);
    }
    if (item?.task_contact) {
      let taskContactElement = item.task_contact;
      if (item.task_contact.length > 0) taskContactElement = item.task_contact[item.task_contact.length - 1];
      this.email = ko.observable(taskContactElement.email_address);
      this.phone = ko.observable(taskContactElement.phone);
      this.contact_full_name = ko.observable(taskContactElement.first_name + " " + taskContactElement.last_name);
    }
    if (item?.request) {
      this.req_user_def8 = ko.observable(item.request.user_def8);
      this.description = ko.observable(item.request.reqextens_user_def5);
      this.installation_date = ko.observable(item.request.installation_date);
      this.cust_prob_descr = ko.observable(item.request.cust_prob_descr);
      this.customer_ref = ko.observable(item.request.customer_ref);
      this.wos_own_ref = ko.observable(item.request.user_def13);
      this.user_def6 = ko.observable(item.request.user_def6);
      this.user_def13 = ko.observable(item.request.user_def13);
      this.user_def7 = ko.observable(item.request.user_def7);
    }

    this.machine_serial_id = ko.observable(item?.request_unit?.serial_id);

    if (item?.request_unit) {
      this.model = ko.observable(item.request_unit.model_id);
      this.contract_des = ko.observable(item.request_unit.model ? item.request_unit.model.internal_descriptn : "");

      if (item.request_unit.contr_product) {
        let contrProductElement = item.request_unit.contr_product;
        if (item.request_unit.contr_product.length > 0)
          contrProductElement = item.request_unit.contr_product[item.request_unit.contr_product.length - 1];
        if (contrProductElement.contr_type instanceof Array) {
          this.contract_type = ko.observable(contrProductElement.contr_type[0]);
          this.contract_description = ko.observable(contrProductElement.contr_type[1].description);
        } else {
          this.contract_type = ko.observable(contrProductElement.contr_type);
          this.contract_description = ko.observable(contrProductElement.contr_type);
        }
      } else if (item.request_unit.contr_type) {
        let contrProductElement = item.request_unit.contr_type;
        if (item.request_unit.contr_type.length > 0)
          contrProductElement = item.request_unit.contr_type[item.request_unit.contr_type.length - 1];
        if (contrProductElement instanceof Array) {
          this.contract_type = ko.observable(contrProductElement[0].contr_type);
          this.contract_description = ko.observable(contrProductElement[0].description);
        } else {
          this.contract_type = ko.observable(contrProductElement.contr_type);
          this.contract_description = ko.observable(contrProductElement.description);
        }
      }
    }

    //#region Product
    this.part_id = ko.observable(item?.product?.part_id);
    this.equipment_no = ko.observable(item?.product?.user_def19);
    this.location = ko.observable(item?.product?.user_def1);
    //#endregion

    if (item?.c_task_sap) this.sales_order = ko.observable(item.c_task_sap.sales_order_no);

    if (item?.c_task_member_view) {
      this.assigned_date_dt = ko.observable(this.formatJSONDate(item.c_task_member_view.assigned_date));
      this.assigned_date_dttm = CustomObservables.formattedDateTimeObservable(this.assigned_date_dt);
    }

    this.action_code_no = ko.observableArray();
    if (item?.c_action_code1)
      if (item.c_action_code1 instanceof Array) {
        this.action_code_no(_.map(item.c_action_code1, (entity) => new action_code(entity)));
      } else {
        this.action_code_no.push(new action_code(item.c_action_code1));
      }

    this.steps = ko.observableArray();
    if (item?.task_steps) {
      if (item.task_steps instanceof Array) {
        this.steps(_.map(item.task_steps, (entity) => new step(entity)));
      } else {
        this.steps.push(new step(item.task_steps));
      }
    }
    this.partNeeds = ko.observableArray();
    if (item?.part_need) {
      if (item.part_need instanceof Array) {
        this.partNeeds(_.map(item.part_need, (entity) => new part_need(entity)));
      } else {
        this.partNeeds.push(new part_need(item.part_need));
      }
    }
    this.nonPartUsage = ko.observableArray();
    if (item?.non_part_usage) {
      if (item.non_part_usage instanceof Array) {
        this.nonPartUsage(_.map(item.non_part_usage, (entity) => new non_part_usage(entity)));
      } else {
        this.nonPartUsage.push(new non_part_usage(item.non_part_usage));
      }
    }
    this.attachments = ko.observableArray();
    if (item?.task_attachment) {
      if (item.task_attachment instanceof Array) {
        this.attachments(_.map(item.task_attachment, (entity) => new attachment_wrapper(entity)));
      } else {
        this.attachments.push(new attachment_wrapper(item.task_attachment));
      }
    }

    this.canInteract = ko.observable(false);

    if (item?.c_task_sparepart) {
      this.c_task_sparepart = <KnockoutObservableArray<c_task_sparepart>>(
        this.loadRelation(item, c_task_sparepart, "c_task_sparepart", "array")
      );
    } else this.c_task_sparepart = ko.observableArray();

    this.c_product_structure_serials_view = ko.observableArray();
    if (this.task_type && this.task_type() == "INSTALL") {
      if (item?.request_unit && item?.request_unit.c_product_structure_serials_view)
        this.c_product_structure_serials_view = <KnockoutObservableArray<c_product_structure_serials_view>>(
          this.loadRelation(
            item.request_unit,
            c_product_structure_serials_view,
            "c_product_structure_serials_view",
            "array",
          )
        );
    }
    this.readonly = ko.pureComputed(() => {
      return (
        (this.status && (this.status() == "COMPLETED" || this.status() === "REJECTED")) || this.is_historical_task()
      );
    });
    if (item?.time_commit_view) {
      this.time_commit_view = <KnockoutObservableArray<time_commit_view>>(
        this.loadRelation(item, time_commit_view, "time_commit_view", "array")
      );
    } else {
      this.time_commit_view = ko.observableArray();
    }

    if (item?.c_task_member_view && item?.c_task_member_view.service_model)
      this.service_model = ko.observable(item.c_task_member_view.service_model);

    this.user_def16 = ko.observable(item?.user_def16 ? item?.user_def16 : "");

    this.part_usage = ko.observableArray();
    this.readings = ko.observableArray(new Array());
    this.notes = ko.observableArray(new Array(new screenNote({})));

    this.team = <KnockoutObservable<any>>this.loadRelation(item, team, "team");

    this.geocode_lat = ko.observable(item?.geocode_lat);
    this.geocode_long = ko.observable(item?.geocode_long);

    this.person = <KnockoutObservable<person>>this.loadRelation(item, person, "person");

    this.task_template_id = ko.observable(item?.task_template_id);
  }
}
